import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services';

@Pipe({
  name: 'translate',
  standalone: true
})
export class TranslationPipe implements PipeTransform {
  languageService: LanguageService;

  constructor(service: LanguageService) {
    this.languageService = service;
  }

  transform(value: string): string {
    return this.languageService.translate(value);
  }
}
